// extracted by mini-css-extract-plugin
export default {"tooltip":"So-z","sharingV2":"To-z","sharingIconsV2":"Uo-z","links":"Vo-z","link":"Wo-z","facebookV2":"Xo-z","twitterV2":"Yo-z","pinterestV2":"Zo-z"};